import React from 'react';
import CustomSearchInput from './customSearchInput';

export default [
  <CustomSearchInput source="Query" alwaysOn placeholder="keyword" />,
];
